import cx from 'classnames';
import SanityImage from '@otovo/shared/components/Sanity/SanityImage';
import SanityPortableTextComponents from '@otovo/shared/components/Sanity/SanityPortableTextComponents';
import { Sanity$TestimonialSection } from '@otovo/shared/types/sanityTypes';
import { PortableText } from '@portabletext/react';
import CustomHeading from '../../../ProductPage/components/CustomHeading';

type Props = {
  content: Sanity$TestimonialSection;
};

const TestimonialSection = ({ content }: Props) => {
  const headingStyles = 'mb-4 text-2xl font-medium text-[#1B2438] md:text-3xl';

  return (
    <div
      className={cx(
        'flex w-full flex-col bg-lilac-5 text-grey-60 md:flex-row 2xl:items-center',
      )}
    >
      <div className="overflow-hidden md:w-1/2">
        <SanityImage
          image={content.image}
          className="h-full max-h-[550px] w-full rounded-none object-cover"
        />
      </div>
      <div className="m-auto flex flex-col justify-start gap-10 p-8 md:w-1/2 lg:p-14 2xl:gap-20">
        <div>
          <CustomHeading
            heading={content.heading}
            headingStyles={headingStyles}
          />
          <PortableText
            value={content.customerQuote}
            components={{
              ...SanityPortableTextComponents,
              block: {
                normal: ({ children }) => (
                  <div className="text-sm font-light italic xl:text-lg">
                    {children}
                  </div>
                ),
              },
            }}
          />
        </div>
        <div className="mt-auto">
          <div className="font-bold xl:text-lg">{content.product}</div>
          <div className="text-base font-light">{content.location}</div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
